import { setDevicePref, setUserPref, UserOrganisation } from '@eventr/common'
import { Gutters } from '@eventr/common-storybook'
import { deviceDetect } from 'react-device-detect'
import { useShallow } from 'zustand/react/shallow'
import i18n from '../../../i18n/i18next'
import { bs, useBoundStore } from '../../../state/bound.store'
import { loadingSignal } from '../../../state/overlayState/overlaySignals'
import { useThemeContext } from '../../../state/themeState/themeContext'
import { getDevicePrefName } from '../../../utils'
import { useGuestStore } from '../../guest/guest.store'
import { NavigationView } from '../../layout/NavigationView'
import { ToolbarItemProps } from '../../layout/TopToolbar'
import { OrgSelector } from './orgSelector'

export const ChangeOrgPage = () => {
    const { selectedOrg, profile } = useBoundStore(
        useShallow((s) => {
            return {
                selectedOrg: s.selectedOrg,
                profile: s.profile,
            }
        })
    )

    const handleOrgChange = async (org: UserOrganisation) => {
        setDevicePref('theme', '', getDevicePrefName(deviceDetect))
        useThemeContext.getState().setOverride(false)
        loadingSignal.value = true
        useGuestStore.setState(useGuestStore.getInitialState())
        await bs().setSelectedOrg(org)
        loadingSignal.value = false
    }

    const trailingItems = () => {
        if (!bs().checkUserOwnership()) {
            return [
                {
                    id: 'trailingItemAddButton',
                    icon: 'Add',
                    popoverItems: [
                        {
                            id: 'createNewTeamButton',
                            title: i18n.t('account.createTeam'),
                            action: () => {
                                window.pushPath(
                                    '/authentication/teamname?thisUser=true'
                                )
                            },
                        },
                    ],
                },
            ] as ToolbarItemProps[]
        }

        return []
    }

    return (
        <NavigationView
            navigationBarTitle={i18n.t('account.swapTeam')}
            backButtonAction={() => {
                window.goBack()
            }}
            usePageTransition
            navigationBarTrailing={trailingItems()}
        >
            <Gutters>
                <OrgSelector
                    organisations={profile?.organisations || []}
                    selectedOrg={selectedOrg}
                    onSelect={(org) => {
                        handleOrgChange(org)
                        setUserPref('account', 'defaultOrg', org.name)
                    }}
                />
            </Gutters>
        </NavigationView>
    )
}
